import ComisionDelete from './ComisionDelete'
export {ComisionDelete}
export default ComisionDelete
